import DeleteEmployerModal from './DeleteEmployerModal'

export default DeleteEmployerModal
